module.exports = __webpack_public_path__ + "static/concept5-pc-991b9d7c4fbc4e20d54faa547d7a0901.svg";